import React, { useState, useEffect, useRef } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import PropTypes from 'prop-types';
import './styles.scss';
import styled from 'styled-components';

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
`;

const MultiSearchSelect = props => {
    const {
        input,
        data,
        valueField,
        labelField,
        id,
        label,
        meta,
        isDisabled,
        displayLabel,
        entityType,
        handleSearchEnd,
    } = props;

    const [finalOptions, setFinalOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const lastSearchValue = useRef('');

    const handleChange = selected => {
        console.log(selected, 'selectedselected');
        setSelectedOptions(selected);
        input.onChange(selected.map(option => option.value));
    };

    const handleBlur = () => {
        input.onBlur(input.value);
    };

    useEffect(() => {
        const finalOptionsTemp = data.map(option => ({
            label: option[labelField],
            value: option[valueField],
        }));

        setFinalOptions(finalOptionsTemp);
    }, [labelField, data, valueField]);

    const filterOptions = (options, filter) => {
        if (!filter || filter.trim().length < 3) {
            return options;
        }

        const searchValue = filter.trim().toLowerCase();

        const filtered = options.filter(
            ({ label }) =>
                typeof label === 'string' &&
                label.toLowerCase().includes(searchValue)
        );

        if (
            typeof handleSearchEnd === 'function' &&
            filtered.length === 0 &&
            lastSearchValue.current !== searchValue
        ) {
            handleSearchEnd(searchValue, entityType);
            lastSearchValue.current = searchValue;
        }

        return filtered;
    };

    useEffect(() => {
        if (Array.isArray(input.value)) {
            const initialSelected = input.value.map(val =>
                finalOptions.find(option => option.value === val));
            setSelectedOptions(initialSelected.filter(Boolean));
        }
    }, [input.value, finalOptions]);

    return (
        <div className="multi-search-select-wrapper">
            {displayLabel ? (
                <label className={'custom-label'}>{label}</label>
            ) : (
                <></>
            )}
            <MultiSelect
                className={'multi-select-component'}
                options={finalOptions}
                value={selectedOptions}
                onChange={handleChange}
                onBlur={handleBlur}
                labelledBy={label || 'Select'}
                disable={isDisabled}
                classNamePrefix="multi-search-select"
                filterOptions={filterOptions}
            />
            {meta.touched && meta.error && (
                <ErrorWrapper className="error-message">
                    {meta.error}
                </ErrorWrapper>
            )}
        </div>
    );
};

MultiSearchSelect.propTypes = {
    valueField: PropTypes.string.isRequired,
    labelField: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    input: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
    }).isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
    isDisabled: PropTypes.bool,
    displayLabel: PropTypes.bool,
    entityType: PropTypes.string,
    handleSearchEnd: PropTypes.func,
};

export default MultiSearchSelect;
